import axios from 'axios';
import Constants from '@/constants';

class ProductTransactionService {
    constructor() {
        this.table_name = 'realestate.product_transaction'
        this.table_name_view = 'realestate.product_transaction_view'
    }

    async listAllByProduct (productId) {
        var query = `SELECT * FROM ${this.table_name_view} WHERE product_id='${productId}' ORDER BY created_at DESC`

        query = encodeURI(query);
        var url = Constants.HOST_URL + 'runSelectQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);

            return response.data;
        } 
        catch(err) {
            alert(err);
        }
    }
  
    async submitTransaction(product_id, seller_id, buyer_id, price_bought, date_bought, notes, created_by ) {
        
        var columns = [
            'product_id', 
            'seller_id', 
            'buyer_id', 
            'price_bought', 
            'date_bought',
            'notes',
            'created_by'
        ];
        var values = [
            `${product_id}`, 
            `${seller_id}`,
            `${buyer_id}`,
            `${price_bought}`,
            `'${date_bought}'`,
            `'${notes}'`,
            `'${created_by}'`
        ];

        var query = `INSERT INTO ${this.table_name} (`;
        query += columns.join(',');
        query += ') VALUES (';
        query += values.join(',');
        query += ');';

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);

            this.id = response.data.insertId;
        }
        catch (e) {
            alert(e);
        }
    }

    // async updateLogEntry(id, description) {
    //     var query = `UPDATE ${this.table_name} SET description='${description}' WHERE id =${id}`;

    //     var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

    //     try {
    //         var response = await axios.get(url);
    //         console.log(response.data);
    //     }
    //     catch (e) {
    //         alert(e);
    //     }
    // }

    async remove(id) {
        var query = `DELETE FROM ${this.table_name} WHERE id =${id}`;

        var url = Constants.HOST_URL + 'runInsertQuery?query=' + query;

        try {
            var response = await axios.get(url);
            console.log(response.data);
        }
        catch (e) {
            alert(e);
        }
    }
  }
  
  
export default ProductTransactionService;